import React, { useContext } from 'react';
import '../TopCabsRoutes/TopCabsRoutes.css';
import queryString from 'query-string';
import { CabData } from '../../pages/runtime-typechecker';
import { formatDuration } from '../../utils/timeUtils';
import { Context } from '../../AppContext';
import { setDateAsDatePlusN, setPickupTime } from '../../utils/timeUtils';
import BPG from '../BPG/BPG';
import { CASE_CAB_CARD } from '../../constants/omniture';
import { useMediaQuery } from 'react-responsive';
import { extractTemplateTypeFromOmniUrlArgs } from '../../utils/stringUtils';
import { isWebView } from '../../utils/commonUtils';
import { TEMPO_TRAVELLER } from '../../constants/miscellaneousConstants';
const isSSR = () => typeof window === 'undefined';

type TopCarTypeCabRoutesProps = {
  // setWidget?: any;
  cityName: string;
  carTypeName?: string;
  routeType: string;
  data: CabData[];
  // setcollapsableFlag?: any;
  noOfListings?: number;
  isMobileDevice?: boolean;
  enableAnchorTags?: boolean;
  reduceCssCalculations?: boolean;
};
const TopCabsRoutes = ({
  // setWidget,
  cityName,
  carTypeName,
  routeType,
  data,
  // setcollapsableFlag,
  noOfListings = 8,
  enableAnchorTags = false,
  reduceCssCalculations = true
}: // isMobileDevice
TopCarTypeCabRoutesProps) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
  const templateType = extractTemplateTypeFromOmniUrlArgs(omniUrlArgs);
  const trackClick = (fromCity: string, toCity: string) => {
    trackTemplateEvent(
      ((): string => {
        if (
          templateType == 'Route_Car_Type_Template' ||
          templateType == 'City_Car_Type_Template'
        ) {
          return `Cab_SEO_Top_Route_${routeType}_City_${fromCity}-${toCity}_${carTypeName}_View_Cab_Click`;
        }
        return `Cab_SEO_Top_Route_${routeType}_City_${carTypeName}_View_Cab_Click`;
      })()
    );
  };
  const getRedirectionUrl = (
    url: string | undefined,
    forwardDate: number | undefined
  ) => {
    if (!url) return;
    const query = queryString.parseUrl(url).query;
    const fromCity = query['fromCity'];
    const toCity = query['toCity'];
    const redirectionUrl =
      !isSSR() && isWebView()
        ? `${setDateAsDatePlusN(
            `mmyt://react/?page=cabsListing&deeplink=true&to=${toCity}&from=${fromCity}&tripType=OW&startDate=21-08-2020&${omniUrlArgs}${CASE_CAB_CARD}`
          )}`
        : `${setPickupTime(
            setDateAsDatePlusN(url, 1, forwardDate)
          )}&${omniUrlArgs}${CASE_CAB_CARD}`;
    window.location = Object(redirectionUrl);
  };

  return (
    <div
      className={`${
        reduceCssCalculations ? `visibilityAuto` : ``
      } makeRelative`}
    >
      <div className="cabTypeWrap">
        <div className={`cabTypeDetails`}>
          <table
            style={{ width: '100%', border: '1px solid #cecece' }}
            className="noBorder"
          >
            {!isMobileDevice ? (
              <>
                <thead id={'desktop'}>
                  <tr
                    style={{ width: '100%' }}
                    className="cabTypeHead noBorder"
                  >
                    <th style={{ width: '34%', textAlign: 'start' }}>
                      <span className="cabTypeCol">
                        {carTypeName
                          ? `Top ${cityName} ${carTypeName} Routes`
                          : `Cabs ${routeType.toLowerCase()} ${cityName}`}
                      </span>
                    </th>
                    <th style={{ width: '27%' }}>
                      <span className="cabTypeCol">
                        Included kms & Extra fare
                      </span>
                    </th>
                    <th style={{ width: '36%' }}>
                      <span className="cabTypeCol appendRight30">
                        {' '}
                        Cab Price
                      </span>
                    </th>
                    <th style={{ width: '' }}>
                      <span className="cabTypeCol viewDtl"> &nbsp;</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data
                    .filter((_, index) => {
                      return isSSR() ? true : index < noOfListings;
                    })
                    .map((item: CabData, index: number) => {
                      return (
                        <>
                          <tr
                            style={{ width: '100%' }}
                            key={index + routeType}
                            className={
                              index === 0 ? 'cabTypeRow noBdr' : 'cabTypeRow'
                            }
                          >
                            {/* <tr style={{width:"100%"}}> */}
                            <td
                              style={{
                                width: '40%',
                                border: '1px solid #cecece'
                              }}
                            >
                              <div className="cabTypeCol">
                                <p className="cabTypeRoute">
                                  {item.seoUrl ? (
                                    <a
                                      className={`${
                                        enableAnchorTags
                                          ? 'cabTypeRouteLinkHover'
                                          : 'pointerEventNone'
                                      } cabTypeRoute`}
                                      href={item.seoUrl}
                                    >
                                      {item.route}
                                    </a>
                                  ) : (
                                    <span className="cabTypeRoute">
                                      {item.route}
                                    </span>
                                  )}
                                </p>
                                <p className="cabTimeDis">
                                  {(() => {
                                    if (carTypeName === TEMPO_TRAVELLER) {
                                      return (
                                        <>
                                          {item?.seat_count
                                            ? `${item.seat_count} passengers | `
                                            : ''}
                                          {item.ac_string ? item.ac_string : ''}
                                        </>
                                      );
                                    } else {
                                      return (
                                        <>
                                          {item.oneway_distance_in_kms} kms |{' '}
                                          {item.oneway_duration_in_minutes
                                            ? formatDuration(
                                                item.oneway_duration_in_minutes
                                              )
                                            : null}
                                        </>
                                      );
                                    }
                                  })()}
                                </p>
                              </div>
                            </td>
                            <td
                              style={{
                                width: item.strike_off_amount ? '40%' : '40%',
                                border: '1px solid #cecece'
                              }}
                            >
                              <div className="cabTypeCol">
                                <p className="cabTypeIncDis">
                                  {item.included_kms} kms included
                                </p>
                                <p className="cabTypeFare">
                                  Extra fare ₹{item.per_km_charge}/km after{' '}
                                  {item.included_kms} kms
                                </p>
                              </div>
                            </td>
                            <td
                              style={{
                                width: item.strike_off_amount ? '18%' : '18%',
                                border: '1px solid #cecece'
                              }}
                            >
                              <div className="cabTypeCol">
                                <p className="cabTypePrice">
                                  ₹{item.total_amount}
                                  {item.strike_off_amount ? (
                                    <span className="appendLeft5 strikeOffPrice">
                                      ₹{item.strike_off_amount}
                                    </span>
                                  ) : null}
                                </p>
                                <p className="cabTypeOnwards">
                                  {item?.tolls_and_taxes_text}
                                </p>
                              </div>
                            </td>
                            <td
                              style={{
                                width: '15%',
                                border: '1px solid #cecece'
                              }}
                            >
                              <div className="cabTypeCol">
                                <a
                                  className="viewCabBtn"
                                  onClick={e => {
                                    e.preventDefault();
                                    if (
                                      item.sourceCity &&
                                      item.destinationCity
                                    ) {
                                      trackClick(
                                        item.sourceCity,
                                        item.destinationCity
                                      );
                                    }
                                    let forwardDate;
                                    if (carTypeName == TEMPO_TRAVELLER) {
                                      forwardDate = 1;
                                    }
                                    getRedirectionUrl(
                                      item.redirection_url,
                                      forwardDate
                                    );
                                  }}
                                  href={item.redirection_url}
                                >
                                  {' '}
                                  VIEW CABS
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            {!isSSR() && item.best_price_guarantee_details ? (
                              <td className="noBorder">
                                <BPG
                                  bpgInfo={item.best_price_guarantee_details}
                                  isMobileDevice={false}
                                  fromCity={
                                    item.sourceCity ? item.sourceCity : ''
                                  }
                                  toCity={
                                    item.destinationCity
                                      ? item.destinationCity
                                      : ''
                                  }
                                />
                              </td>
                            ) : null}
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              </>
            ) : (
              <>
                <div className="makeFlex TopRouteCabsCarTypeHeading appendTop10">
                  <div
                    className={`TopRouteCabsCarTypeHeadingColumn appendRight30`}
                  >{`Top ${cityName} Routes`}</div>
                  <div
                    className={` TopRouteCabsCarTypeHeadingColumn appendRight30`}
                  >{`Included kms & Extra fare`}</div>
                  <div
                    className={` TopRouteCabsCarTypeHeadingColumn `}
                  >{`Price`}</div>
                </div>
                <tbody>
                  {data
                    .filter((_, index) => {
                      return isSSR() ? true : index < noOfListings;
                    })
                    .map((item: CabData, index: number) => {
                      return (
                        <>
                          <tr
                            key={index}
                            className={
                              index === 0 ? 'cabTypeRow noBdr' : 'cabTypeRow'
                            }
                          >
                            <a
                              onClick={e => {
                                e.preventDefault();
                                if (item.sourceCity && item.destinationCity) {
                                  trackClick(
                                    item.sourceCity,
                                    item.destinationCity
                                  );
                                }
                                let forwardDate;
                                if (carTypeName == TEMPO_TRAVELLER) {
                                  forwardDate = 1;
                                }
                                getRedirectionUrl(
                                  item.redirection_url,
                                  forwardDate
                                );
                              }}
                              href={item.redirection_url}
                            >
                              <td
                                style={{ border: '1px solid #cecece' }}
                                className="cabTypeCol"
                              >
                                <p>
                                  {item.seoUrl ? (
                                    <a
                                      className="pointerEventNone cabTypeRoute"
                                      href={item.seoUrl}
                                    >
                                      {item.route}
                                    </a>
                                  ) : (
                                    <span className="cabTypeRoute">
                                      {item.route}
                                    </span>
                                  )}
                                </p>
                                <p className="cabTimeDis">
                                  {(() => {
                                    if (carTypeName === TEMPO_TRAVELLER) {
                                      return (
                                        <>
                                          {item?.seat_count
                                            ? `${item.seat_count} passengers | `
                                            : ''}
                                          {item.ac_string ? item.ac_string : ''}
                                        </>
                                      );
                                    } else {
                                      return (
                                        <>
                                          {item.oneway_distance_in_kms} kms |{' '}
                                          {item.oneway_duration_in_minutes
                                            ? formatDuration(
                                                item.oneway_duration_in_minutes
                                              )
                                            : null}
                                        </>
                                      );
                                    }
                                  })()}
                                </p>
                              </td>
                              <td
                                style={{ border: '1px solid #cecece' }}
                                className="cabTypeCol"
                              >
                                <p className="cabTypeIncDis">
                                  {item.included_kms} kms included
                                </p>
                                <p className="cabTypeFare">
                                  Extra fare ₹{item.per_km_charge}/km after{' '}
                                  {item.included_kms} kms
                                </p>
                              </td>
                              <td
                                style={{ border: '1px solid #cecece' }}
                                className="cabTypeCol"
                              >
                                {item.strike_off_amount ? (
                                  <div className="pushRight appendBottom3">
                                    <p className="strikeOffPrice">
                                      ₹{item.strike_off_amount}
                                    </p>
                                  </div>
                                ) : null}
                                <p className="cabTypePrice">
                                  ₹{item.total_amount}
                                </p>
                                <p className="cabTypeOnwards paddingT5">
                                  {item?.tolls_and_taxes_text}
                                </p>
                              </td>
                            </a>
                          </tr>
                          <tr>
                            {!isSSR() && item.best_price_guarantee_details ? (
                              <td
                                style={{ border: '1px solid #cecece' }}
                                className="noBorder"
                              >
                                <BPG
                                  bpgInfo={item.best_price_guarantee_details}
                                  isMobileDevice={true}
                                  fromCity={
                                    item.sourceCity ? item.sourceCity : ''
                                  }
                                  toCity={
                                    item.destinationCity
                                      ? item.destinationCity
                                      : ''
                                  }
                                />
                              </td>
                            ) : null}
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              </>
            )}
          </table>
        </div>
      </div>
      {/* <>
        <div className={`showMoreCabs appendTop20Imp makeAbsolute`}>
          {setWidget && data.length > 0 && (
            <button
              className="showMoreCabsButton"
              onClick={() => {
                trackTemplateEvent(
                  `Cab_SEO_Top_Route_${routeType}_City_${carTypeName}_View_Cab_Click`
                );
                isMobileDevice ? setcollapsableFlag(false) : setWidget(4);
              }}
            >
              {'VIEW MORE'}
            </button>
          )}
        </div>
      </> */}
    </div>
  );
};

export default TopCabsRoutes;
